module.exports = __webpack_public_path__ + "img/wallet.e20a812a.svg";